import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: {path: '/source'}
    },
    {
        path: '/source',
        name: 'source',
        component: () => import('@/views/dashboard'),
    },{
        path: '/xjd/base',
        name: 'base',
        component: () => import('@/views/baseInfo'),
    }, {
		path: '/farm/detail',
		name: 'farmDetail',
		component: () => import('@/views/farmDetail')
	}

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
